
import React from 'react';
import { Procurement } from '@/types/database.types';

interface RequestorInfoSectionProps {
  procurement: Procurement;
}

export const RequestorInfoSection: React.FC<RequestorInfoSectionProps> = ({
  procurement
}) => {
  if (!procurement?.requestor) {
    return null;
  }

  return (
    <div className="mb-4">
      <h3 className="text-lg font-medium mb-2">Requestor Information</h3>
      <div className="bg-muted/50 p-3 rounded-md">
        <div className="text-sm text-muted-foreground">
          Requested by: {procurement.requestor?.first_name || ''} {procurement.requestor?.last_name || ''} ({procurement.requestor?.role || 'Unknown'})
        </div>
      </div>
    </div>
  );
};
